import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_LINK } from "@/pages/home/constants";

export default function CtaSection() {
  return (
    <section id="contato" className="relative py-8 md:py-11 bg-accent-500 scroll-mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8 reveal">
          <div className="text-center md:text-left">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-primary-950 mb-2 leading-tight">
              Pronto para viver
              <br className="hidden md:block" />
              essa experiência?
            </h2>
            <p className="text-xs md:text-sm text-primary-900/80 max-w-md">
              Fale agora com a Eco Tour Turismo e reserve seu passeio de lancha em Capitólio — fechando
              com a gente, você ainda pode ganhar ingressos e descontos em parques e cachoeiras.
            </p>
          </div>
          <div className="flex flex-col items-center md:items-end gap-3">
            <a
              href={WHATSAPP_LINK}
              data-whatsapp-cta
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md text-sm font-bold bg-primary-950 text-white hover:bg-primary-900 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg" />
              Quero reservar meu passeio
            </a>
            <a
              href={`tel:${PHONE_TEL}`}
              className="flex items-center gap-2 text-sm font-bold text-primary-950 cursor-pointer"
            >
              <i className="ri-phone-line" />
              <span>{PHONE_DISPLAY}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}